// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2cdyI","dragIcon":"SortableItem_dragIcon__3YYu8","disabled":"SortableItem_disabled__2xstL"};